module.exports = __webpack_public_path__ + "static/media/logo-header-white.bbea4ccd.png";